// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".solutions-menu[data-v-f1b66f2a]{display:flex;flex-direction:column;padding:0}@media (min-width: 1024px){.solutions-menu[data-v-f1b66f2a]{min-width:800px;flex-direction:row}}.extended-block[data-v-f1b66f2a]{padding:30px}.extended-block h6[data-v-f1b66f2a]{font-size:12px;font-weight:600;margin-bottom:20px;text-transform:uppercase;color:#9096a0}.user-block[data-v-f1b66f2a]{padding:30px;background:#fffae9}\n", ""]);
// Exports
module.exports = exports;
